import { create } from 'zustand';

/**
 * Module-scope store for "open the member sidebar in-page from every
 * launcher:campaign chip" (plan unit U11a). Store-only: the state-links /
 * StatePills / host wiring that calls `open()` from a campaign chip is unit
 * U11b; units U14b and U18 import this store directly, so the shape here is
 * load-bearing for those units too. Plain `create<State>((set) => ({ ... }))`
 * per CLAUDE.md "Zustand for Module-Scope Client State" — no curried form, no
 * middleware. Follows `useSignalsUiStore.ts` as the house pattern.
 */
type CampaignMemberSidebarTarget = {
  campaignId: string;
  contactId: string;
  observedAt?: string | null;
  signalStatus?: string | null;
};

export interface CampaignMemberSidebarState {
  /** The campaign/contact pair the sidebar should render for, or null when closed. */
  target: CampaignMemberSidebarTarget | null;
  /** Opens the sidebar for the given target, replacing any prior target. */
  open: (target: CampaignMemberSidebarTarget) => void;
  /** Closes the sidebar. */
  close: () => void;
}

/** Exported per the CLAUDE.md zustand convention — tests reset with `setState(initialState, true)`. */
export const initialState: Pick<CampaignMemberSidebarState, 'target'> = {
  target: null,
};

export const useCampaignMemberSidebarStore = create<CampaignMemberSidebarState>((set) => ({
  ...initialState,
  open: (target) => set({ target }),
  close: () => set({ target: null }),
}));
